import { render, staticRenderFns } from "./FeaturedItems3Template.vue?vue&type=template&id=2983b3d0"
import script from "./FeaturedItems3Template.vue?vue&type=script&lang=js"
export * from "./FeaturedItems3Template.vue?vue&type=script&lang=js"
import style0 from "./FeaturedItems3Template.vue?vue&type=style&index=0&id=2983b3d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports